<template>
  <div class="schoolPageMain">
    <el-tabs v-model="activeName">
      <el-tab-pane label="模板设置" name="1">
        <mubanSetting
          v-auth="'onlineSchool_/pageList'"
          :schoolMenuId="schoolMenuId"
          @changeschoolMenuId="changeschoolMenuId"
        />
      </el-tab-pane>
      <el-tab-pane label="首页" name="2">
        <pcSetting
          schoolPageMenuId="1428889251581440002"
          :schoolMenuId="schoolMenuId"
          v-if="schoolMenuId"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import pcSetting from "./pcSetting";
import mubanSetting from "./mubanSetting";
import menuSetting from "./menuSetting";
import { mapGetters } from "vuex";

export default {
  components: { pcSetting, menuSetting, mubanSetting },
  data() {
    return {
      schoolMenuId: "",
      schoolPageMenuId: "",
      activeName: "1",
      storageUser: {},
      choosedTemplate: "",
      clickedTemp: 0,
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      tempOptions: [],
      searchForm: {
        template: "",
      },
      domain: "",
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
  },

  mounted() {
    this.getIndexAgentInfo();
    this.storageUser = JSON.parse(localStorage.getItem("user")) || {};
    this.getTempDictionary(() => {
      this.api.schoolPage
        .getGeneralSettingDetail({})
        .then((result) => {
          if (result.data) {
            this.domain = result.data.domain;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
  methods: {
    changeschoolMenuId(id) {
      this.schoolMenuId = id;
    },
    getIndexAgentInfo() {
      this.api.agentInfo.getIndexAgentInfo().then((res) => {
        this.schoolMenuId = res.data.templateId;
      });
    },
    // ---------------------------------清除缓存
    delRedis() {
      this.api.schoolPage.delRedis().then((res) => {
        if (res.success) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    lbtbeforeUpload(file) {
      this.loading = true;
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        this.loading = false;
      }
      return isJPG && isLt2M;
    },
    changeItemIndex(index) {
      console.log(index);
      this.clickedTemp = index;
    },
    lbtSuccess(res, file, fileList, val) {
      console.log(res.data);
      this.api.schoolPage
        .updateTempCover({
          id: this.tempOptions[this.clickedTemp].id,
          remark: res.data,
        })
        .then((res) => {
          this.getTempDictionary();
        });
    },
    useThisTemp(id) {
      this.api.schoolPage.updateAgentTemp({ templateId: id }).then((res) => {
        this.getTempDictionary();
        if (res.success) this.$message.success("操作成功");
      });
    },
    getTempDictionary(callback) {
      this.api.dictionary
        .getTempDictionaryData()
        .then((result) => {
          console.log(result);
          this.tempOptions = result.data;
          this.choosedTemplate = result.data[0] ? result.data[0].id : "";
          callback && callback();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.schoolPageMain {
  margin: 10px;
  padding: 10px;
  background-color: #fff;
  position: relative;
}
.viewPc {
  position: absolute !important;
  top: 25px;
  right: 12px;
}
.viewDelRedis {
  position: absolute !important;
  top: 16px;
  right: 50px;
}
.templateTop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;
}
.tempContainer {
  padding-bottom: 60px;
}
.chooseTempBox {
  display: flex;
  flex-direction: row;
  padding: 0 127px;
  justify-content: space-around;
  .tempItem {
    display: flex;
    flex-direction: column;
    align-content: center;
    p {
      font-weight: 700;
      font-style: normal;
      font-size: 16px;
      color: #455a64;
      margin-bottom: 10px;
    }
    img {
      width: 300px;
      height: 300px;
    }
    .rowBet {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .el-button {
      width: 300px;
      height: 40px;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/index.vue